import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../../shared/providers/base-provider';
import { UbigeoNotifier } from './ubigeo-notifier';
import { UbigeoState } from './ubigeo-state';

@Injectable()
export class UbigeoProvider extends BaseProvider<UbigeoNotifier, UbigeoState> {
  constructor() {
    super(UbigeoNotifier);
    this.trackSessionReset(() => this.notifier.resetState());
  }
}
